import {visit, SKIP} from "unist-util-visit";
import type {Plugin} from "unified";

/**
 * Rehype plugin that converts [^N] text patterns into inline
 * <span class="citation-ref" id="citation-ref-N"> elements.
 * Runs before rehypeSanitize so the spans survive (class+id are allowlisted).
 */
const rehypeCitationRefs: Plugin = () => (tree: any) => {
  visit(tree, "text", (node: any, index: number | undefined, parent: any) => {
    if (!parent || index === undefined) return;
    const regex = /\[\^(\d+)\]/g;
    if (!regex.test(node.value)) return;
    regex.lastIndex = 0;

    const newNodes: any[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = regex.exec(node.value)) !== null) {
      if (match.index > lastIndex) {
        newNodes.push({type: "text", value: node.value.slice(lastIndex, match.index)});
      }
      newNodes.push({
        type: "element",
        tagName: "span",
        properties: {className: ["citation-ref"], id: `citation-ref-${match[1]}`},
        children: [{type: "text", value: `[${match[1]}]`}],
      });
      lastIndex = regex.lastIndex;
    }

    if (lastIndex < node.value.length) {
      newNodes.push({type: "text", value: node.value.slice(lastIndex)});
    }

    parent.children.splice(index, 1, ...newNodes);
    return [SKIP, index + newNodes.length];
  });
};

export default rehypeCitationRefs;
